// API URL from environment variables
// Set in .env.development (for npm start) or .env.production (for npm run build)
// Fallback to localhost for development if not set
export const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:7133/api";

// Get the API base URL without /api for static file serving
export const getApiBaseUrl = (): string => {
  // Remove /api from the end of the URL
  if (API_URL.endsWith("/api")) {
    return API_URL.slice(0, -4);
  }
  // Fallback: remove /api if it exists anywhere
  return API_URL.replace("/api", "");
};

// Convert relative static file path to full URL
export const getStaticFileUrl = (relativePath: string): string => {
  // If it's already a full URL, return as is
  if (
    relativePath.startsWith("http://") ||
    relativePath.startsWith("https://")
  ) {
    return relativePath;
  }

  // Ensure path starts with /
  const cleanPath = relativePath.startsWith("/")
    ? relativePath
    : `/${relativePath}`;
  return `${getApiBaseUrl()}${cleanPath}`;
};
